import * as localizationKeys from '../../consts/localization/localizationKeys';
import {setNotificationInfo} from '../../state/ducks/global';
import {dispatch} from '../../state/store';
import helpers from '../../utils/helpers';
import connectivityService from '../device/connectivityService';
import deviceGlobalConfigService from './iotDeviceGlobalConfigService';

let vibrationAlarmTimeout;

const setVibrationAlarmTimeout = (deviceAlarmDuration, callback) => {
    vibrationAlarmTimeout = setTimeout(() => helpers.runFunction(callback), deviceAlarmDuration);
};

const clearVibrationAlarmTimeout = () => clearTimeout(vibrationAlarmTimeout);

const checkSettingAvailable = (iotDevice, is_supported) => {
    const {device, holder} = iotDevice;
    const isBle = connectivityService.isBle();
    const isGlobalHolderCheck = deviceGlobalConfigService.isGlobalHolderCheck(iotDevice);

    if (isGlobalHolderCheck) {
        if (device?.isHolderConnected && holder?.type) {
            if (!is_supported) {
                dispatch(
                    setNotificationInfo({textKey: localizationKeys.DEVICE_SETTINGS_UPDATE_HOLDER_NOTIFICATION_TEXT})
                );
                return false;
            }
        } else {
            const textKey = isBle
                ? localizationKeys.DEVICE_SETTINGS_INSERT_HOLDER_NOTIFICATION_TEXT
                : localizationKeys.USB_DEVICE_SETTINGS_INSERT_HOLDER_NOTIFICATION_TEXT;

            dispatch(setNotificationInfo({textKey}));
            return false;
        }
    } else if (!is_supported) {
        dispatch(setNotificationInfo({textKey: localizationKeys.DEVICE_SETTINGS_UPDATE_DEVICE_NOTIFICATION_TEXT}));
        return false;
    }
    return true;
};

const checkAdvancedSettingAvailable = (iotDevice, is_suported) => {
    const {device} = iotDevice;
    const isBle = connectivityService.isBle();

    if (device?.isHolderConnected) {
        if (!is_suported) {
            dispatch(setNotificationInfo({textKey: localizationKeys.DEVICE_SETTINGS_UPDATE_HOLDER_NOTIFICATION_TEXT}));
            return false;
        }
        return true;
    } else {
        const textKey = isBle
            ? localizationKeys.DEVICE_SETTINGS_INSERT_HOLDER_NOTIFICATION_TEXT
            : localizationKeys.USB_DEVICE_SETTINGS_INSERT_HOLDER_NOTIFICATION_TEXT;

        dispatch(setNotificationInfo({textKey}));
        return false;
    }
};

const isHolderConnectedAndInSBLMode = ({device, holder}) => device?.isHolderConnected && isHolderInSBLMode({holder});

const isHolderInSBLMode = ({holder}) => {
    return holder?.is_device_in_sbl_mode;
};

const isHolderEngineAvailable = ({holder_engine}) => !!holder_engine;

const isHolderEngineInSBLMode = ({holder_engine}) => holder_engine?.is_device_in_sbl_mode;

export default {
    checkAdvancedSettingAvailable,
    checkSettingAvailable,
    clearVibrationAlarmTimeout,
    isHolderConnectedAndInSBLMode,
    isHolderEngineAvailable,
    isHolderEngineInSBLMode,
    isHolderInSBLMode,
    setVibrationAlarmTimeout,
};
